import {useStateValue} from 'state/index';
import {onException} from "state/httpStatusHandler";
import {viewReport} from "../queries";

const useSecurityCenterReport = () => {
  const [state, dispatch] = useStateValue();
  return async (callback) => {
    await viewReport()
      .then(() => callback())
      .catch(errorObject => onException(errorObject, dispatch, state));
  };
}

export default useSecurityCenterReport;
